"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invert = exports.isTrue = exports.isFalse = void 0;
function isFalse(value) {
    return !value;
}
exports.isFalse = isFalse;
function isTrue(value) {
    return value;
}
exports.isTrue = isTrue;
function invert(value) {
    return !value;
}
exports.invert = invert;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbGVhbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ib29sZWFuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLE9BQU8sQ0FBQyxLQUFjO0lBQ3BDLE9BQU8sQ0FBQyxLQUFLLENBQUM7QUFDaEIsQ0FBQztBQUZELDBCQUVDO0FBRUQsU0FBZ0IsTUFBTSxDQUFDLEtBQWM7SUFDbkMsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDO0FBRkQsd0JBRUM7QUFFRCxTQUFnQixNQUFNLENBQUMsS0FBYztJQUNuQyxPQUFPLENBQUMsS0FBSyxDQUFDO0FBQ2hCLENBQUM7QUFGRCx3QkFFQyJ9